module.exports = __webpack_public_path__ + "static/media/6.ff008533.gif";